// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"my-quotes-loading-state-module__loading-wrapper--I1_","loadingWrapper":"my-quotes-loading-state-module__loading-wrapper--I1_"};